// Map an answer option to a sentiment level + appreciation message.
// Used by the feedback wizard to give instant, contextual feedback after a tap.

const POSITIVE = new Set([
  "Excellent", "Very Good",
  "Yes, completely", "Mostly yes",
  "Always responsive", "Mostly responsive",
  "Yes, very helpful", "Helpful", "Very useful", "Useful",
  "Yes, fully",
  "Always", "Mostly",
  "Yes, very comfortable", "Comfortable",
  "Definitely yes", "Yes",
]);

const NEUTRAL = new Set([
  "Good", "Average",
  "Partially", "Sometimes responsive", "Sometimes",
  "Somewhat helpful", "Basic information only",
  "Maybe",
  "Only with prior approval",
]);

const NEGATIVE = new Set([
  "Needs Improvement",
  "Not clearly", "Not responsive", "Not helpful", "Not useful",
  "No", "Rarely",
]);

const POS_MESSAGES = [
  "Thank you — that means a lot to us. 💙",
  "We're so glad to hear this. Thank you!",
  "Wonderful — your trust keeps us going.",
  "That's heart-warming. Thank you for sharing.",
  "We're truly grateful for your kind words.",
];

const NEU_MESSAGES = [
  "Thanks for being honest — we'll keep getting better.",
  "Noted, and appreciated. We always have room to grow.",
  "Honest feedback is the best gift. Thank you.",
];

const NEG_MESSAGES = [
  "We're truly sorry — your feedback helps us fix it.",
  "Thank you for telling us. We'll work on this with care.",
  "We hear you. We'll do better — promise.",
];

function pick(arr, seed) {
  // Stable selection per option text so the same answer doesn't shuffle the message
  let s = 0;
  for (let i = 0; i < seed.length; i++) s = (s * 31 + seed.charCodeAt(i)) | 0;
  return arr[Math.abs(s) % arr.length];
}

export function appreciate(option) {
  if (!option) return null;
  if (POSITIVE.has(option)) return { tone: "positive", message: pick(POS_MESSAGES, option) };
  if (NEGATIVE.has(option)) return { tone: "negative", message: pick(NEG_MESSAGES, option) };
  if (NEUTRAL.has(option)) return { tone: "neutral", message: pick(NEU_MESSAGES, option) };
  return { tone: "neutral", message: pick(NEU_MESSAGES, option) };
}

export function appreciateStars(value) {
  const v = Number(value || 0);
  if (v >= 5) return { tone: "positive", message: "Five stars! Thank you — you've made our day. 🌟" };
  if (v === 4) return { tone: "positive", message: "Four stars — thank you! We'll aim for that fifth." };
  if (v === 3) return { tone: "neutral", message: "Thanks — we'll keep improving to earn more." };
  if (v === 2) return { tone: "negative", message: "Sorry to hear that. We'll work hard to do better." };
  if (v === 1) return { tone: "negative", message: "We're truly sorry. Your feedback will drive real change." };
  return null;
}
